import React from "react";
import LifeMedicineAcademyView from "../views/LifeMedicineAcademyView";

const LifeMedicineAcademyPage = (props: { location: { pathname: string } }) => {
    return <LifeMedicineAcademyView pathName={props.location.pathname} />;
};

export default LifeMedicineAcademyPage;
